export const CHANGE_APP_STATE = 'CHANGE_APP_STATE';